import { render } from "./Delete_account.vue?vue&type=template&id=d4a06110&scoped=true"
import script from "./Delete_account.vue?vue&type=script&lang=js"
export * from "./Delete_account.vue?vue&type=script&lang=js"

import "./Delete_account.vue?vue&type=style&index=0&id=d4a06110&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a06110"]])

export default __exports__